import { LeftOutlined, LoadingOutlined, UserOutlined } from "@ant-design/icons";
import { DndContext } from "@dnd-kit/core";
import { Avatar, Badge, Button, Divider, Spin, Tooltip } from "antd";
import Cookies from "js-cookie";
import { debounce, delay, uniqBy } from "lodash";
import moment from "moment-timezone";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { AiFillEdit } from "react-icons/ai";
import { FiSend } from "react-icons/fi";
import { GoPersonAdd } from "react-icons/go";
import { HiRefresh } from "react-icons/hi";
import { HiMiniUserGroup } from "react-icons/hi2";
import { IoMenu, IoSearchSharp } from "react-icons/io5";
import { LuAlarmClock } from "react-icons/lu";
import {
  MdExitToApp,
  MdKeyboardDoubleArrowUp,
  MdOutlineGroupOff,
  MdOutlineHowToVote,
} from "react-icons/md";
import { VscLayoutSidebarRight } from "react-icons/vsc";
import { v4 as uuidv4 } from "uuid";
import apiFactory from "../../../api";
import { socketStatus$ } from "../../../api/webSocketRx";
import AvatarComponent from "../../../components/avatar/AvatarComponent";
import { MessageAvatar } from "../../../components/avatar/MessageAvatar";
import { ShowTimeOffline } from "../../../components/avatar/ShowTimeOffline";
import { GenerateMessageContent } from "../../../components/chat/MessageContent";
import { AddMemberModal } from "../../../components/modal/AddMemberModal";
import { ChatScheduleModal } from "../../../components/modal/chat/ChatScheduleModal";
import CreateVoteModal from "../../../components/modal/chat/CreateVoteModal";
import EditGroupModal from "../../../components/modal/chat/EditGroupModal";
import { GeneralModal } from "../../../components/modal/GeneralModal";
import { MediaVideoModal } from "../../../components/modal/MediaVideoModal";
import { MemberModal } from "../../../components/modal/MemberModal";
import MemberReadUnreadModal from "../../../components/modal/MemberReadUnreadModal";
import { ShareMessageModal } from "../../../components/modal/ShareMessageModal";
import StickerItem from "../../../components/moodPack/sticker/StickerItem";
import StickerTable from "../../../components/moodPack/sticker/StickerTable";
import { FilesPreview } from "../../../components/preview/FilesPreview";
import { ContentEditableRichInput } from "../../../components/richInput/ContentEditableRichInput";
import { DirectoryProvider } from "../../../components/select/directory/DirectoryContext";
import { FileSending } from "../../../components/select/FileSending";
import { SideBarConversation } from "../../../components/sideBar/SideBarConversation";
import {
  CHATTING,
  conversationStatus,
  conversationType,
  exceedFiles,
  imagesTypes,
  MAX_FILE_SIZE,
  MESSAGE_STATUS,
  PANEL_STATUS,
  role,
} from "../../../config/Constant";
import { useAuthLayoutContext } from "../../../context/AuthLayoutContext";
import { useChatContext } from "../../../context/ChatContext";
import { useMenuContext } from "../../../context/MenuContext";
import { useUploadFileStore } from "../../../store/UploadFileStore";
import { useInfoUser } from "../../../store/UserStore";
import { updateOrgList } from "../../../utils/OrganizationHelper";
import {
  extractUserIds,
  getAvatar,
  getColorFromInitial,
  onChangeUnreadConversation,
  openNotificationError,
  openNotificationSuccess,
  processFileUrl,
  removeAccents,
} from "../../../utils/Utils";
import { ChatPreviewLink } from "./ChatPreviewLink";
import { NewMessage } from "./NewMessage";
import { GroupInfoPanel } from "./panel/GroupInfoPanel";
import { MediaStoragePanel } from "./panel/MediaStoragePanel";
import { SearchPanel } from "./panel/SearchPanel";
import { PinnedMessage } from "./PinnedMessage";
import { QuotationResponse } from "./Quotation";
import "./style.scss";
import { useSendingContext } from "../../../context/global/SendingProvider";

const fileStore = process.env.REACT_APP_FILE_STORE || "http://10.1.1.230:8000";

const ChatDetail = () => {
  const { user, languageMap, stickerKeywords } = useInfoUser();

  /** Context */
  const { setOrgList: setOriginalOrgList } = useAuthLayoutContext();
  const [orgList, setOrgList] = useState([]);
  const {
    selectedConversation,
    conversationList,
    handleUpdateConversationList,
    isMenu,
    refreshChatMessage,
    onSearch,
    setIsMenu,
    setSelectedConversation,
    quotation,
    setQuotation,
    personalDetail,
    setKeydownMenuOn,
    panelStatus,
    setPanelStatus,
  } = useMenuContext();

  const {
    userListRef,
    messageList,
    setMessageList,
    formData,
    setFormData,
    sendFormData,
    lastMessageTs,
    setLastMessageTs,
    setIsMoreMessage,
    isMoreMessage,
    setIsModalAddMember,
    isOpenModalConfirm,
    setIsOpenModalConfirm,
    onBackToConversations,
    isModalAddMember,
    openAddMemberModal,
    openModalConfirm,
    setIsNewMessage,
    setIsViewTargetMessage,
    isViewTargetMessage,
    viewTargetMessage,
    previousScrollRef,
    messageRef,
    messageMapRef,
    handleTyping,
    typingUsers,
    pinnedMessages,
    isEnableGroup,
    setIsEnableGroup,
    isChatScheduleModal,
    setIsChatScheduleModal,
    setScheduleMessage,
    fetchPinnedMessages,
    wasAtBottomMessageRef,
    jumpedRef,
    updateInitScrollRef,
    updateFirstScrollRef,
    setIsScrollToLastMessage,
    isLoading,
    setIsLoading,
    jumpToMessage,
    handleClickButtonIsNewMessage,
    isJumping,
    getListUserFromMessage,
    searchCacheMention,
    setSearchCacheMention,
    isExitGroup,
    inputValue,
    setInputValue,
    showAllPin,
    setShowAllPin,
    firstMessageUnread,
    setFirstMessageUnread,
    unreadInDOM,
    setUnreadInDOM,
    isMessageUnread,
    setIsMessageUnread,
    initMessageList,
  } = useChatContext();

  const { uploadFiles, setUploadFiles } = useUploadFileStore();

  const { fakeMessages } = useSendingContext();

  const mentionCallbackRef = useRef(null);
  const mentionSearchRef = useRef(null);
  const inputSendRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [openModalShowMember, setOpenModalShowMember] = useState(false);
  const [totalUsersFromConversation, setTotalUsersFromConversation] =
    useState(0);
  const [isModalMembersReadUnread, setIsModalMembersReadUnread] =
    useState(false);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const firstObserver = useRef();
  const lastObserver = useRef();
  const [isShareMessageModal, setIsShareMessageModal] = useState(false);
  const [dataShare, setDataShare] = useState(null);
  const [heightHeader, setHeightHeader] = useState(50);
  const [isOpenMediaModal, setIsOpenMediaModal] = useState(false);
  const [mediaVideo, setMediaVideo] = useState({
    mediaVideoSrc: null,
    shortName: null,
  });
  const [countReconnectedSuccessWs, setCountReconnectedSuccessWs] = useState(1);
  const [isOpenModalVote, setIsOpenModalVote] = useState(false);
  const [showSticker, setShowSticker] = useState(false);
  const [stickerSuggestions, setStickerSuggestions] = useState([]);

  const observerRef = useRef(null);

  const abortControllerRef = useRef(new AbortController());

  const headerRef = useRef(null);

  const firstElementRef = (node) => {
    if (isLoading || !isMoreMessage) return;

    if (firstObserver.current) firstObserver.current.disconnect();

    firstObserver.current = new IntersectionObserver(async (entries) => {
      if (entries[0].isIntersecting) {
        setIsLoading(true);
        previousScrollRef.current = messageRef.current.scrollHeight;

        const res = await apiFactory.messageApi.getList({
          limit: CHATTING.MESSAGE_LIMIT,
          maxTs: lastMessageTs,
          search: {
            conversationId: selectedConversation?.conversationId,
          },
          direction: "DESC",
        });

        if (res?.status !== 200) {
          openNotificationError(res?.message);
          return;
        }

        const users = await getListUserFromMessage(res?.data);
        let uniqUsers = userListRef.current;

        if (users?.length) {
          userListRef.current = uniqBy(
            [...(userListRef.current || []), ...(users || [])],
            "userId",
          );
        }

        const messList = res?.data
          ?.map((item) => ({
            ...item,
            isSelf: item?.senderId === user?.userId,
            username: uniqUsers?.filter(
              (u) => u?.userId === item?.senderId,
            )?.[0]?.name,
            conversationId: selectedConversation?.conversationId,
            photos: processFileUrl(
              item?.photos,
              "/conversation/",
              selectedConversation?.conversationId,
            ),
            progress: 1,
          }))
          .reverse();
        setMessageList((prev) => [
          { shadow: true },
          ...messList,
          ...(prev?.slice(1) || []),
        ]);
        setLastMessageTs(messList[0]?.createdAt);
        setIsMoreMessage(messList?.length === CHATTING?.MESSAGE_LIMIT);
        updateFirstScrollRef.current = true;
        setIsLoading(false);
      }
    });

    if (node) firstObserver.current.observe(node);
  };

  const lastElementRef = (node) => {
    if (isLoading || !isViewTargetMessage) return;
    if (lastObserver.current) lastObserver.current.disconnect();
    lastObserver.current = new IntersectionObserver(async (entries) => {
      if (entries[0].isIntersecting) {
        setIsLoading(true);

        const res = await apiFactory.messageApi.getList({
          limit: CHATTING.MESSAGE_LIMIT,
          minTs: messageList[messageList?.length - 1]?.createdAt,
          search: {
            conversationId: selectedConversation?.conversationId,
          },
          direction: "ASC",
        });

        if (res?.status !== 200) {
          openNotificationError(res?.message);
          return;
        }

        const users = await getListUserFromMessage(res?.data);
        let uniqUsers = userListRef.current;
        if (users?.length) {
          userListRef.current = uniqBy(
            [...(userListRef.current || []), ...(users || [])],
            "userId",
          );
          uniqUsers = userListRef.current;
        }
        const messList = res?.data?.map((item) => ({
          ...item,
          isSelf: item?.senderId === user?.userId,
          username: uniqUsers?.filter((u) => u?.userId === item?.senderId)?.[0]
            ?.name,
          conversationId: selectedConversation?.conversationId,
          photos: processFileUrl(
            item?.photos,
            "/conversation/",
            selectedConversation?.conversationId,
          ),
          progress: 1,
        }));

        setMessageList((prev) => [...(prev || []), ...messList]);
        setIsViewTargetMessage(messList?.length === CHATTING?.MESSAGE_LIMIT);
        setIsScrollToLastMessage(messList?.length === CHATTING?.MESSAGE_LIMIT);
        jumpedRef.current = messList?.length === CHATTING?.MESSAGE_LIMIT;
        setIsLoading(false);
      }
    });
    if (node) lastObserver.current.observe(node);
  };

  const scrollToBottom = async () => {
    if (isViewTargetMessage) {
      // initMessageList();
      setIsScrollToLastMessage(false);
    } else if (
      messageRef?.current?.scrollHeight > messageRef?.current?.clientHeight
    ) {
      setIsNewMessage(false);
      delay(() => {
        if (messageRef?.current)
          messageRef.current.scrollTop = messageRef.current.scrollHeight;
      }, 200);
    }
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const onScrollMessageList = (event) => {
    const el = event.currentTarget;
    const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 10;
    wasAtBottomMessageRef.current = atBottom;
    if (atBottom) {
      setIsScrollToLastMessage(false);
      setIsNewMessage(false);
    } else {
      setIsScrollToLastMessage(true);
    }
  };

  const showModalShowMember = async () => {
    setOpenModalShowMember(true);
  };

  const fetchLink = async (extractedLink) => {
    if (!extractedLink) return;

    const result = await apiFactory.previewApi.getLinkPreview({
      url: extractedLink,
    });

    if (result?.status !== 200) {
      setFormData({
        ...formData,
        previewLink: {
          image: null,
          title: null,
          description: null,
          url: null,
        },
      });
    } else {
      setFormData({
        ...formData,
        previewLink: {
          ...result?.data,
        },
      });
    }
  };

  const removePreviewLink = () => {
    setFormData({
      ...formData,
      previewLink: {
        image: null,
        title: null,
        description: null,
        url: null,
      },
    });
  };

  const handleCancelModalShowMember = () => {
    setOpenModalShowMember(false);
  };

  const getListMemberInfo = () => {
    //first element is shadow
    setTotalUsersFromConversation(
      messageList?.[1]?.memberCount || totalUsersFromConversation,
    );
  };

  const closeModalConfirm = () => {
    setIsOpenModalConfirm(false);
  };

  const exitGroup = async () => {
    const memberExitGroup = await apiFactory.userConversationApi.exitGroup({
      conversationId: selectedConversation?.conversationId,
    });

    if (memberExitGroup?.status !== 200) {
      openNotificationError(memberExitGroup?.message);
      return;
    }

    openNotificationSuccess(
      languageMap?.["success.leftGroup"] ?? "You have left the group",
    );
  };

  const deleteGroup = async () => {
    const result = await apiFactory.conversationApi.deleteGroup(
      selectedConversation?.conversationId,
    );

    if (result?.status !== 200) {
      openNotificationError(result?.message);
    }
  };

  const disableGroup = async () => {
    const result = await apiFactory.conversationApi.disableGroup(
      selectedConversation?.conversationId,
    );

    if (result?.status !== 200) {
      openNotificationError(result?.message);
    }
  };

  const enableGroup = async () => {
    const result = await apiFactory.conversationApi.enableGroup(
      selectedConversation?.conversationId,
    );

    setIsEnableGroup(false);
    setIsNewMessage(true);
    if (result?.status !== 200) {
      openNotificationError(result?.message);
    }
  };

  const isNotShowAvatar = (prevMessage, currentMessage) => {
    if (
      !prevMessage ||
      !currentMessage ||
      moment(prevMessage?.createdAt).format("YYYY-MM-DD") !==
        moment(currentMessage?.createdAt).format("YYYY-MM-DD") ||
      ![
        MESSAGE_STATUS.TEXT,
        MESSAGE_STATUS.FILE,
        MESSAGE_STATUS.TEXT,
        MESSAGE_STATUS.STICKER,
        MESSAGE_STATUS.REMOVE_MESSAGE,
      ].includes(prevMessage?.contentType)
    )
      return false;

    return prevMessage?.senderId === currentMessage?.senderId;
  };

  const isNotShowTime = (nextMessage, currentMessage) => {
    if (
      !nextMessage ||
      !currentMessage ||
      moment(nextMessage?.createdAt).format("YYYY-MM-DD hh:mm") !==
        moment(currentMessage?.createdAt).format("YYYY-MM-DD hh:mm") ||
      ![
        MESSAGE_STATUS.TEXT,
        MESSAGE_STATUS.FILE,
        MESSAGE_STATUS.TEXT,
        MESSAGE_STATUS.STICKER,
        MESSAGE_STATUS.REMOVE_MESSAGE,
      ].includes(nextMessage?.contentType)
    )
      return false;

    return nextMessage?.senderId === currentMessage?.senderId;
  };

  const getTitleAndContent = () => {
    if (isEnableGroup) {
      return {
        title: languageMap?.["menu.conversation.enableGroup"] ?? "Enable group",
        content:
          languageMap?.["modal.wantToEnable"] ??
          "Do you want to enable this group?",
      };
    }

    if (isExitGroup) {
      return {
        title: languageMap?.["menu.conversation.exitGroup"] ?? "Exit group",
        content:
          languageMap?.["modal.wantToExit"] ?? "Do you want to exit group?",
      };
    }

    return {
      title: languageMap?.["menu.conversation.disableGroup"] ?? "Disable group",
      content:
        languageMap?.["modal.wantToDisable"] ?? "Do you want to disable group?",
    };
  };

  const handleOnConfirmDisableGroup = async () => {
    closeModalConfirm();

    const disableConversationIndex = conversationList?.findIndex(
      (conversation) =>
        conversation?.conversationId === selectedConversation?.conversationId,
    );

    let updatedStatus = "INACTIVE";
    if (isEnableGroup) {
      updatedStatus = "ACTIVE";
    }

    const updatedConversation = {
      ...selectedConversation,
      conversationStatus: updatedStatus,
    };
    setSelectedConversation(updatedConversation);

    if (disableConversationIndex !== -1) {
      conversationList[disableConversationIndex] = updatedConversation;

      const newConversationListSorted = conversationList;

      handleUpdateConversationList(newConversationListSorted);
    }

    if (isEnableGroup) {
      await enableGroup();
    } else if (isExitGroup) {
      await exitGroup();
    } else {
      await disableGroup();
    }
  };

  const sendMessage = (e) => {
    e.preventDefault();
    const cleanedInputValue = inputValue
      ?.split("\n")
      ?.filter((line) => line.length > 0)
      ?.join("\n");

    setFormData({
      ...formData,
      text: cleanedInputValue,
      quotation,
      previewLink: {
        image: null,
        title: null,
        description: null,
        url: null,
      },
    });

    sendFormData({
      ...formData,
      text: cleanedInputValue,
      conversationId: selectedConversation?.conversationId,
      quotation,
    });

    setInputValue("");
    scrollToBottom();
    setQuotation(null);
  };

  const onKeyDown = (e) => {
    // Prevent Enter during Korean/IME composition
    if (e.isComposing || e.keyCode === 229 || e.keyCode !== 13) return;

    if (!e.shiftKey) {
      sendMessage(e);
    } else if (wasAtBottomMessageRef.current) {
      // chỉ kéo xuống khi user đang ở đáy trước đó
      requestAnimationFrame(() => {
        if (messageRef.current) {
          messageRef.current.scrollTop = messageRef.current.scrollHeight;
        }
      });
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDrop = (event) => {
    event.preventDefault();

    if (formData?.files?.length > exceedFiles) {
      openNotificationError(
        languageMap?.["error.exceed.fileNumber"] ??
          "The number of files exceeds 24",
      );
      return;
    }

    const items = event.dataTransfer?.items;
    if (items) {
      let hasFolder = false;

      for (let i = 0; i < items.length; i++) {
        const entry = items[i].webkitGetAsEntry?.();
        if (entry && entry.isDirectory) {
          hasFolder = true;
          break;
        }
      }

      if (hasFolder) {
        openNotificationError(
          languageMap?.["error.not.sendFolder"] ?? "You can not send folder",
        );
        return;
      }
    }

    const droppedFiles = Array.from(event.dataTransfer.files)?.filter(
      (file) => file?.size !== 0,
    );

    let totalSizeUpload = droppedFiles.reduce((sum, f) => sum + f.size, 0);
    if (totalSizeUpload > MAX_FILE_SIZE) {
      openNotificationError("File size exceeds the 1gb limit");
      return;
    }

    const mediaFiles = [];
    const encodePhotos = [];
    const promises = [];

    droppedFiles.forEach((file) => {
      file.uid = uuidv4();

      const promise = new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = (e) => {
          const base64 = e?.target?.result;
          if (imagesTypes.includes(file?.type)) {
            const img = new Image();
            img.src = base64;

            img.onload = () => {
              file.width = img.width;
              file.height = img.height;
              resolve();
            };
          } else {
            mediaFiles.push(file);
            resolve();
          }
        };
      });

      promises.push(promise);
    });

    Promise.all(promises).then(() => {
      setFormData((prev) => ({
        ...prev,
        text: prev?.text,
        files: [...(prev?.files || []), ...droppedFiles],
        mediaFiles: [...(prev?.mediaFiles || []), ...mediaFiles],
        encodePhotos: [...(prev?.encodePhotos || []), ...encodePhotos],
      }));

      setUploadFiles([...uploadFiles, ...(mediaFiles || [])]);
    });
  };

  const handleMediaModal = useCallback((isOpen, src, shortName) => {
    setIsOpenMediaModal(isOpen);
    setMediaVideo({
      mediaVideoSrc: src,
      shortName: shortName,
    });
  }, []);

  const handleFileChange = (e) => {
    if (formData?.files?.length === exceedFiles) {
      openNotificationError(
        languageMap?.["error.exceed.fileNumber"] ??
          "The number of files exceeds 24",
      );
      return;
    }

    const text = formData.text;
    const clipboardFiles = Array.from(e.clipboardData.items)
      .filter((item) => item.kind === "file")
      .map((item) => {
        const file = item.getAsFile();
        file.uid = uuidv4();
        return file;
      });

    if (clipboardFiles.length === 0) return;

    e.preventDefault();

    const filePromises = clipboardFiles.map((file) => {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = (r) => {
          if (imagesTypes.includes(file.type)) {
            const img = new Image();
            img.src = r.target.result;
            img.onload = () => {
              resolve({
                type: "image",
                data: {
                  name: file.name,
                  contentCode: r.target.result,
                  uid: file.uid,
                  width: img.width,
                  height: img.height,
                },
                file,
              });
            };
          } else {
            resolve({
              type: "media",
              data: file,
              file,
            });
          }
        };
      });
    });

    Promise.all(filePromises).then((results) => {
      const encodePhotos = [];
      const mediaFiles = [];

      results.forEach((result) => {
        if (result.type === "image") {
          encodePhotos.push(result.data);
        } else {
          mediaFiles.push(result.data);
        }
      });

      const updatedFiles = [...(formData?.files || []), ...clipboardFiles];
      const updatedMediaFiles = [
        ...(formData?.mediaFiles || []),
        ...mediaFiles,
      ];
      const updatedEncodePhotos = [
        ...(formData?.encodePhotos || []),
        ...encodePhotos,
      ];

      setFormData({
        text,
        files: updatedFiles,
        mediaFiles: updatedMediaFiles,
        encodePhotos: updatedEncodePhotos,
      });

      setUploadFiles([...uploadFiles, ...(mediaFiles || [])]);
    });
  };

  const fetchLastedMessages = async () => {
    if (!selectedConversation?.conversationId) return;

    const rs = await apiFactory.messageApi.haveNewMessage(
      selectedConversation?.conversationId,
    );

    if (rs?.status === 200) {
      setIsNewMessage(rs?.data);
    }
  };

  const fetchMissedMessages = async () => {
    const minTs = messageList?.[1]?.createdAt;
    if (!minTs) return;

    setIsLoading(true);
    const countOldMessages = messageList?.length || 0;

    try {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }

      abortControllerRef.current = new AbortController();

      const res = await apiFactory.messageApi.getList(
        {
          minTs,
          search: {
            conversationId: selectedConversation?.conversationId,
          },
          direction: "ASC",
        },
        { signal: abortControllerRef.current.signal },
      );

      if (res?.status !== 200) {
        openNotificationError(res?.message);
        return;
      }

      const users = await getListUserFromMessage(res?.data);

      let uniqUsers = userListRef.current;
      if (users?.length) {
        userListRef.current = [
          ...(userListRef.current || []),
          ...(users || []),
        ];
        uniqUsers = uniqBy(userListRef.current, "userId");
      }

      const messList = res?.data?.map((item) => ({
        ...item,
        isSelf: item?.senderId === user?.userId,
        username: uniqUsers?.find((u) => u?.userId === item?.senderId)?.name,
        conversationId: selectedConversation?.conversationId,
        photos: processFileUrl(
          item?.photos,
          "/conversation/",
          selectedConversation?.conversationId,
        ),
        progress: 1,
      }));

      let sortedMessages = messList?.sort(
        (a, b) => new Date(a?.createdAt) - new Date(b?.createdAt),
      );

      if (countOldMessages < res?.data?.length) setIsNewMessage(true);

      sortedMessages = [
        ...sortedMessages,
        ...Object.values(
          fakeMessages?.[selectedConversation?.conversationId] || {},
        ),
      ];

      setMessageList([{ shadow: true }, ...sortedMessages]);
    } catch (error) {
      return;
    } finally {
      setIsScrollToLastMessage(true);
      setIsLoading(false);
    }
  };

  const handleDataMentions = (search, callback) => {
    mentionSearchRef.current = search;
    mentionCallbackRef.current = callback;

    const mentionIds = extractUserIds(inputValue);

    const createFilteredMentionList = (mentionList) => {
      return mentionList.filter((item) => !mentionIds.includes(item?.id));
    };

    const cachedMentionAll = searchCacheMention.get("");

    if (cachedMentionAll && !cachedMentionAll.isMoreMember) {
      const filteredList = cachedMentionAll.memberMentionList.filter(
        ({ display }) =>
          removeAccents(display)
            .toLowerCase()
            .includes(removeAccents(search).toLowerCase()),
      );
      callback(createFilteredMentionList(filteredList));
      return;
    }

    const cachedMention = searchCacheMention.get(search);

    if (cachedMention) {
      callback(createFilteredMentionList(cachedMention.memberMentionList));
    } else {
      const hasConsecutiveSpaces = /\s{2,}/.test(search);

      if (hasConsecutiveSpaces) return;

      debounceFetchMembers(
        search,
        (members) => {
          callback(createFilteredMentionList(members));
        },
        selectedConversation?.conversationId,
      );
    }
  };

  const fetchMembers = async (
    memberName,
    callback,
    conversationId,
    page = 1,
  ) => {
    setIsLoading(true);

    try {
      const request = {
        conversationId: conversationId,
        limit: 30,
        page,
        search: { memberName, viewType: "ALL" },
        ts: moment(),
      };

      const result =
        await apiFactory?.userConversationApi?.getListUserConversation(request);
      setIsLoading(false);

      if (result?.status === 200) {
        const newMembers =
          result?.data?.items?.map(({ userId, name, avatar }) => ({
            id: userId,
            display: name,
            avatar,
          })) || [];

        setSearchCacheMention((prevCache) => {
          const cache = new Map(prevCache);
          const existingData = cache.get(memberName) || {
            memberMentionList: [],
            memberPage: 1,
            isMoreMember: false,
          };
          let updatedList =
            page === 1
              ? newMembers
              : [...existingData.memberMentionList, ...newMembers];

          if (!updatedList.some((member) => member.id === "ALL")) {
            updatedList = [{ id: "ALL", display: "All" }, ...updatedList];
          }

          const userLogin = useInfoUser.getState().user;

          cache.set(memberName, {
            memberMentionList: updatedList.filter(
              (item) => item?.id !== userLogin?.userId,
            ),
            memberPage: page + 1,
            isMoreMember: newMembers.length === 30,
          });
          callback(
            updatedList.filter((item) => item?.id !== userLogin?.userId),
          );
          return cache;
        });

        updateOrgList(setOriginalOrgList, result?.data?.items);
      } else {
        openNotificationError(result?.message);
      }
    } catch (error) {
      setIsLoading(false);
      openNotificationError("Failed to fetch members.");
    }
  };

  const handleScroll = useCallback(
    (event) => {
      const target = event.target;
      const cachedData = searchCacheMention.get(mentionSearchRef.current);

      if (
        target.scrollTop + target.clientHeight >= target.scrollHeight &&
        cachedData?.isMoreMember
      ) {
        fetchMembers(
          mentionSearchRef.current,
          mentionCallbackRef.current,
          selectedConversation?.conversationId,
          cachedData.memberPage,
        );
      }
    },
    [searchCacheMention, selectedConversation?.conversationId],
  );

  const debounceFetchMembers = useCallback(debounce(fetchMembers, 600), []);

  const renderMemberTyping = useMemo(() => {
    if (!Object.entries(typingUsers)?.length) return;

    if (Object.entries(typingUsers)?.length === 1) {
      return (
        <div className="typing">
          {Object.values(typingUsers)?.[0]?.userName}
          {user?.language === "us" && " is"}{" "}
          {languageMap?.["chat.user.typing"] ?? "typing"}{" "}
        </div>
      );
    }

    return (
      Object.entries(typingUsers).length > 0 && (
        <div className="typing">
          {Object.values(typingUsers)
            ?.map((typingUser) => typingUser?.userName)
            ?.slice(0, 3)
            ?.join(", ")}{" "}
          {user?.language === "us" && "are"}{" "}
          {languageMap?.["chat.user.typing"] ?? "typing"}{" "}
        </div>
      )
    );
  }, [typingUsers, languageMap]);

  const extractSingleLink = async (text) => {
    const urlRegex = /https?:\/\/[^\s]+/g;
    const matches = text.match(urlRegex);

    if (matches?.length === 1) {
      await fetchLink(matches[0]);
    } else {
      setFormData({
        ...formData,
        previewLink: {
          image: null,
          title: null,
          description: null,
          url: null,
        },
      });
    }
  };

  const handleAddEmoji = (emojiKey) => {
    if (inputSendRef?.current?.insertEmoji) {
      inputSendRef.current.focus();
      inputSendRef.current.insertEmoji(emojiKey);
    }
  };

  const handleSendSticker = async (sticker) => {
    const payload = {
      conversationId: selectedConversation?.conversationId,
      requestUuid: uuidv4(),
      stickerId: sticker.stickerId,
      content: sticker.resourceId,
      token: Cookies.get("access_token"),
      contentType: "STICKER",
      frameCount: sticker.frameCount,
    };

    await apiFactory.messageApi.sendMessage(payload);
  };

  const getFirstMessageUnread = async () => {
    const request = {
      conversationId: selectedConversation.conversationId,
      lastSeenTs: selectedConversation?.lastSeenTs,
    };
    const response = await apiFactory.messageApi.getFirstMessageUnread(request);

    if (response?.status === 200) {
      setFirstMessageUnread(response?.data);
      setIsMessageUnread(true);
    }
  };

  const getContainer = () => {
    return messageRef?.current || document.querySelector(".message-detail");
  };

  const getSender = () => {
    if (
      !selectedConversation?.memberList?.length ||
      !selectedConversation?.members?.length ||
      !user?.userId
    )
      return null;

    const otherUserId = selectedConversation?.memberList.find(
      (id) => id?.toLowerCase() !== user.userId.toLowerCase(),
    );

    if (!otherUserId) return null;

    return selectedConversation?.members.find(
      (m) => m.userId?.toLowerCase() === otherUserId.toLowerCase(),
    );
  };

  useEffect(() => {
    const interval = setInterval(
      () => {
        setSearchCacheMention(new Map());
      },
      60 * 60 * 1000,
    );
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (messageRef.current) {
      if (updateInitScrollRef.current) {
        updateInitScrollRef.current = false;
        messageRef.current.scrollTop = messageRef.current.scrollHeight;
        wasAtBottomMessageRef.current = true;
      }

      if (updateFirstScrollRef.current) {
        updateFirstScrollRef.current = false;
        messageRef.current.scrollTop =
          messageRef.current.scrollHeight - previousScrollRef.current;
      }

      if (
        wasAtBottomMessageRef.current &&
        messageRef.current &&
        !jumpedRef.current
      ) {
        delay(() => {
          if (messageRef?.current)
            messageRef.current.scrollTop = messageRef.current.scrollHeight;
        }, 200);
      }
    }
  }, [messageList]);

  useEffect(() => {
    getListMemberInfo();
  }, [messageList, lastMessageTs]);

  useEffect(() => {
    if (!headerRef.current) return;

    const observer = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const newHeight = entry.contentRect.height;
        setHeightHeader(newHeight);
      }
    });

    observer.observe(headerRef.current);

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    let suggestionsList = null;

    const handleScrollBar = () => {
      const newSuggestionsList = document.querySelector(
        ".mentions__suggestions",
      );
      if (newSuggestionsList !== suggestionsList) {
        if (suggestionsList) {
          suggestionsList.removeEventListener("scroll", handleScroll);
        }
        if (newSuggestionsList) {
          newSuggestionsList.addEventListener("scroll", handleScroll);
        }
        suggestionsList = newSuggestionsList;
      }
    };

    const observer = new MutationObserver(handleScrollBar);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
      if (suggestionsList) {
        suggestionsList.removeEventListener("scroll", handleScroll);
      }
    };
  }, [handleScroll]);

  useEffect(() => {
    const sub = socketStatus$.subscribe((eventData) => {
      if (!eventData) return;

      if (
        eventData?.status === "CONNECTED" &&
        countReconnectedSuccessWs < eventData?.connectedSuccess
      ) {
        setCountReconnectedSuccessWs(eventData?.connectedSuccess);
        // fetchLastedMessages();
        // fetchMissedMessages();
        initMessageList();
        fetchPinnedMessages();
      }
    });

    return () => sub.unsubscribe();
  }, [
    selectedConversation?.conversationId,
    user?.userId,
    fakeMessages?.[selectedConversation?.conversationId]?.length,
  ]);

  useEffect(() => {
    if (
      selectedConversation?.unreadCount > 0 &&
      selectedConversation?.lastSeenTs
    ) {
      getFirstMessageUnread();
    }
  }, [selectedConversation]);

  useEffect(() => {
    const container = getContainer();
    if (!container) {
      return;
    }

    if (observerRef.current) {
      observerRef.current.disconnect();
      observerRef.current = null;
    }

    observerRef.current = new IntersectionObserver(
      (entries) => {
        let changed = false;

        entries.forEach((entry) => {
          const el = entry.target;
          if (!el || !(el instanceof HTMLElement)) return;

          if (entry.isIntersecting) {
            if (el.dataset.isUnread === "1") {
              el.dataset.isUnread = "0";
              changed = true;
              try {
                observerRef.current.unobserve(el);
              } catch (e) {}
            }
          }
        });

        if (changed) {
          const containerNow = getContainer();
          const readCount = containerNow
            ? containerNow.querySelectorAll('.message-item[data-is-unread="0"]')
                .length
            : 0;
          setUnreadInDOM(readCount);
        }
      },
      {
        root: container,
        threshold: 0.1,
      },
    );

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
        observerRef.current = null;
      }
    };
  }, []);

  return (
    <div className=" overflow-hidden flex flex-row flex-1">
      <div className="w-full">
        <DndContext>
          <div
            className="chat-content h-[100vh]"
            onDragOver={handleDragOver}
            onDrop={handleDrop}
          >
            <div
              className={`header border-b-[1px] border-[#ddd] shadow-md z-10000
                 ${pinnedMessages?.length > 0 && "mb-[50px]"}
                `}
              ref={headerRef}
            >
              <div className="left-chat">
                <button
                  className="btn-back-to-conversation-list"
                  onClick={onBackToConversations}
                >
                  <LeftOutlined />
                </button>
                {selectedConversation?.type === "PERSONAL" ? (
                  <MessageAvatar person={getSender()} styleCss={{}} />
                ) : (
                  <AvatarComponent conversation={selectedConversation} />
                )}

                <div>
                  <div className="text-[#000] text-[16px] font-bold">
                    {selectedConversation?.name}
                  </div>
                  {![
                    conversationType.PERSONAL,
                    conversationType.SELF,
                    conversationType.SYSTEM,
                  ].includes(selectedConversation?.type) &&
                    totalUsersFromConversation > 1 && (
                      <button onClick={showModalShowMember}>
                        <span>
                          <UserOutlined className="bg-[#2a56b9] mr-1 text-[white] p-[4px] rounded-[2px]" />
                          <span className="mr-1">
                            {totalUsersFromConversation}
                          </span>
                          {languageMap?.["messageList.header.prefixMember"] ??
                            "members"}
                        </span>
                      </button>
                    )}
                  {conversationType.PERSONAL === selectedConversation?.type && (
                    <ShowTimeOffline
                      personalDetail={personalDetail}
                      languageMap={languageMap}
                      user={user}
                    />
                  )}
                </div>
                {selectedConversation?.type !== conversationType.SYSTEM &&
                  selectedConversation?.conversationStatus === "ACTIVE" &&
                  (selectedConversation?.role === role?.HOST ||
                    selectedConversation?.type ===
                      conversationType.PERSONAL) && (
                    <button onClick={openModal}>
                      <div className="icon-edit">
                        <AiFillEdit className="text-[#333333] text-[16px] center" />
                      </div>
                    </button>
                  )}
              </div>
              <button
                className="icon menu-icon"
                onClick={() => {
                  setIsMenu(true);
                }}
              >
                <IoMenu size={25} />
              </button>

              <div className="right">
                {selectedConversation?.role !== role.MEMBER &&
                  selectedConversation?.conversationStatus === "ACTIVE" &&
                  ![conversationType.PERSONAL, conversationType.SELF].includes(
                    selectedConversation?.type,
                  ) && (
                    <Tooltip
                      placement="bottom"
                      title={
                        languageMap?.["menu.conversation.addMember"] ??
                        "Add more members"
                      }
                      trigger={"hover"}
                      color={"#0091ff"}
                    >
                      <div>
                        <Button
                          className="bg-[#2a56b9] text-[white]"
                          onClick={openAddMemberModal}
                          icon={<GoPersonAdd size={18} />}
                        />
                      </div>
                    </Tooltip>
                  )}

                <Tooltip
                  placement="bottom"
                  title={
                    languageMap?.["menu.conversation.searchMessage"] ??
                    "Search messages"
                  }
                  color={"#0091ff"}
                >
                  <Button
                    className="bg-[#2a56b9] text-[white]"
                    onClick={onSearch}
                    icon={<IoSearchSharp className="text-[18px]" />}
                  />
                </Tooltip>

                <Tooltip
                  placement="bottom"
                  title={
                    languageMap?.["menu.conversation.refresh"] ?? "Refresh"
                  }
                  color={"#0091ff"}
                >
                  <div>
                    <Button
                      className="bg-[#2a56b9] text-[white]"
                      onClick={() => {
                        refreshChatMessage();
                        setIsMessageUnread(false);
                      }}
                      icon={<HiRefresh className="text-[18px]" />}
                    />
                  </div>
                </Tooltip>
                {selectedConversation &&
                  ![
                    conversationType.PERSONAL,
                    conversationType.SELF,
                    conversationType.SYSTEM,
                  ].includes(selectedConversation?.type) && (
                    <>
                      {isExitGroup && (
                        <Tooltip
                          placement="bottom"
                          title={
                            languageMap?.["menu.conversation.exitGroup"] ??
                            "Exit group"
                          }
                          color="#0091ff"
                        >
                          <Button
                            className="bg-[#2a56b9] text-white"
                            onClick={openModalConfirm}
                            icon={<MdExitToApp className="text-[18px]" />}
                          />
                        </Tooltip>
                      )}
                      {selectedConversation?.conversationStatus ===
                        conversationStatus.ACTIVE &&
                        !isExitGroup && (
                          <Tooltip
                            placement="bottom"
                            title={
                              languageMap?.["menu.conversation.disableGroup"] ??
                              "Disable group"
                            }
                            color="#0091ff"
                          >
                            <Button
                              className="bg-[#2a56b9] text-white"
                              onClick={openModalConfirm}
                              icon={
                                <MdOutlineGroupOff className="text-[18px]" />
                              }
                            />
                          </Tooltip>
                        )}
                      {selectedConversation?.conversationStatus ===
                        conversationStatus.INACTIVE &&
                        !isExitGroup && (
                          <Tooltip
                            placement="bottom"
                            title={
                              languageMap?.["menu.conversation.enableGroup"] ??
                              "Enable group"
                            }
                            color="#0091ff"
                          >
                            <Button
                              className="bg-[#2a56b9] text-white"
                              onClick={() => {
                                setIsEnableGroup(true);
                                openModalConfirm();
                              }}
                              icon={<HiMiniUserGroup className="text-[18px]" />}
                            />
                          </Tooltip>
                        )}
                    </>
                  )}
                <Tooltip
                  placement="bottom"
                  title={
                    languageMap?.["menu.conversation.groupInfo"] ??
                    "Group information"
                  }
                  color={"#0091ff"}
                >
                  <div>
                    <Button
                      className="bg-[#2a56b9] text-white"
                      onClick={() => {
                        setPanelStatus((prev) => {
                          if (
                            [
                              PANEL_STATUS.GROUP_INFO,
                              PANEL_STATUS.MEDIA_STORAGE,
                            ].includes(prev)
                          )
                            return null;
                          return PANEL_STATUS.GROUP_INFO;
                        });
                      }}
                      icon={
                        <VscLayoutSidebarRight
                          size={20}
                          className="!text-[18px]"
                        />
                      }
                    />
                  </div>
                </Tooltip>
              </div>
            </div>

            <div className="pinned-message">
              <PinnedMessage
                data={pinnedMessages}
                jumpToMessage={jumpToMessage}
                selectedConversation={selectedConversation}
                heightHeader={heightHeader}
                showAllPin={showAllPin}
                setShowAllPin={setShowAllPin}
              />
            </div>
            <div
              className="bg-[#EAEEF0] overflow-y-scroll border-none outline-none message-detail w-[100%] px-[10px]"
              ref={messageRef}
              tabIndex={0}
              onFocus={() => setKeydownMenuOn(false)}
              onBlur={() => setKeydownMenuOn(true)}
              onScroll={onScrollMessageList}
              onClick={() => setShowSticker(false)}
            >
              {(isJumping || isLoading) && (
                <div className="spin-container">
                  <Spin
                    indicator={<LoadingOutlined className="text-[35px]" spin />}
                  />
                </div>
              )}
              {isMessageUnread &&
                Math.max(
                  0,
                  (selectedConversation?.unreadCount || 0) - unreadInDOM,
                ) > 0 && (
                  <div className="unread-message-container">
                    <Badge
                      count={Math.max(
                        0,
                        (selectedConversation?.unreadCount || 0) - unreadInDOM,
                      )}
                      color="#2a56b9"
                    >
                      <Button
                        shape="circle"
                        size="large"
                        icon={<MdKeyboardDoubleArrowUp size={30} />}
                        onClick={() => {
                          if (!firstMessageUnread) return;
                          jumpToMessage(firstMessageUnread);
                          setIsMessageUnread(false);
                        }}
                      />
                    </Badge>
                  </div>
                )}
              {user &&
                messageList?.map((message, index) => {
                  const isUnreadInit =
                    selectedConversation?.lastSeenTs < message.createdAt
                      ? "1"
                      : "0";
                  const showUnreadLine =
                    message?.requestUuid === firstMessageUnread?.requestUuid;

                  if (index === 0) {
                    //add more shadow message
                    return (
                      <div
                        key={"shadow-item"}
                        ref={firstElementRef}
                        className="h-[100px]"
                      />
                    );
                  }

                  if (index === messageList?.length - 1) {
                    return (
                      <div
                        key={message?.requestUuid}
                        className="message-item"
                        ref={(el) => {
                          if (el) {
                            lastElementRef(el);

                            messageMapRef.current[message?.requestUuid] = el;

                            el.dataset.isUnread =
                              el.dataset.isUnread ?? isUnreadInit;

                            if (
                              observerRef.current &&
                              el.dataset.isUnread === "1"
                            ) {
                              try {
                                observerRef.current.observe(el);
                              } catch (e) {}
                            }
                          }
                        }}
                        data-is-unread={
                          selectedConversation.lastSeenTs < message.createdAt
                            ? "1"
                            : "0"
                        }
                        data-request-uuid={message?.requestUuid}
                      >
                        {showUnreadLine && (
                          <Divider
                            style={{ borderColor: "#2a56b9" }}
                            className="text-blue-500"
                          >
                            <div className="bg-white text-[14px] text-[#2a56b9] px-3 py-1 rounded-full shadow-sm">
                              Unread messages
                            </div>
                          </Divider>
                        )}
                        <GenerateMessageContent
                          isNotShowAvatar={isNotShowAvatar(
                            index > 0 ? messageList?.[index - 1] : {},
                            message,
                          )}
                          isNotShowTime={isNotShowTime(
                            index > 0 ? messageList?.[index + 1] : {},
                            message,
                          )}
                          message={message}
                          fileStore={fileStore}
                          setIsModalMembersReadUnread={
                            setIsModalMembersReadUnread
                          }
                          setSelectedMessage={setSelectedMessage}
                          selectedConversation={selectedConversation}
                          setQuotation={setQuotation}
                          jumpToMessage={jumpToMessage}
                          viewTargetMessage={viewTargetMessage}
                          inputSendRef={inputSendRef}
                          setIsShareMessageModal={setIsShareMessageModal}
                          setDataShare={setDataShare}
                        />
                        <div className="h-[28px]" />
                      </div>
                    );
                  }

                  return (
                    <div
                      key={message?.requestUuid}
                      className="message-item"
                      data-is-unread={
                        selectedConversation.lastSeenTs < message.createdAt
                          ? "1"
                          : "0"
                      }
                      data-request-uuid={message.requestUuid}
                      ref={(el) => {
                        if (el) {
                          messageMapRef.current[message?.requestUuid] = el;

                          el.dataset.isUnread =
                            el.dataset.isUnread ?? isUnreadInit;

                          if (
                            observerRef.current &&
                            el.dataset.isUnread === "1"
                          ) {
                            try {
                              observerRef.current.observe(el);
                            } catch (e) {}
                          }
                        }
                      }}
                    >
                      {showUnreadLine && (
                        <Divider
                          style={{ borderColor: "#2a56b9" }}
                          className="text-blue-500"
                        >
                          <div className="bg-white text-[#2a56b9] px-3 py-1 rounded-full shadow-sm">
                            Unread messages
                          </div>
                        </Divider>
                      )}
                      <GenerateMessageContent
                        isNotShowAvatar={isNotShowAvatar(
                          index > 0 ? messageList[index - 1] : {},
                          message,
                        )}
                        isNotShowTime={isNotShowTime(
                          messageList?.[index + 1] || {},
                          message,
                        )}
                        message={message}
                        fileStore={fileStore}
                        setIsModalMembersReadUnread={
                          setIsModalMembersReadUnread
                        }
                        setSelectedMessage={setSelectedMessage}
                        selectedConversation={selectedConversation}
                        setQuotation={setQuotation}
                        jumpToMessage={jumpToMessage}
                        viewTargetMessage={viewTargetMessage}
                        inputSendRef={inputSendRef}
                        setIsShareMessageModal={setIsShareMessageModal}
                        setDataShare={setDataShare}
                      />
                    </div>
                  );
                })}
              <NewMessage
                handleClickButtonIsNewMessage={handleClickButtonIsNewMessage}
                scrollToBottom={scrollToBottom}
              />
            </div>
            {selectedConversation?.type !== conversationType.SYSTEM &&
              selectedConversation?.conversationStatus === "ACTIVE" && (
                <div
                  className="bg-[#ffffff] input relative !p-[0] z-[101]"
                  style={{
                    borderTopLeftRadius:
                      Object.entries(typingUsers)?.length > 0 ? "unset" : "",
                  }}
                >
                  {renderMemberTyping}

                  <div className="w-[100%] flex flex-col">
                    <div className="border-y-[1px] border-[#ddd] px-[10px] py-[5px] gap-2 flex">
                      <StickerTable
                        onStickerSend={handleSendSticker}
                        onEmojiSelect={handleAddEmoji}
                      />

                      <FileSending
                        formData={formData}
                        setFormData={setFormData}
                      />

                      <Tooltip
                        placement="top"
                        title={
                          languageMap?.["modal.conversation.vote"] ?? "Vote"
                        }
                        color={"#0091ff"}
                      >
                        <Button
                          className="bg-[#2a56b9] text-[white]"
                          icon={<MdOutlineHowToVote className="text-[18px]" />}
                          onClick={() => setIsOpenModalVote(true)}
                        />
                      </Tooltip>

                      <Tooltip
                        placement="top"
                        title={
                          languageMap?.["modal.conversation.schedule"] ??
                          "Schedule"
                        }
                        color={"#0091ff"}
                      >
                        <Button
                          className="bg-[#2a56b9] text-[white]"
                          icon={<LuAlarmClock className="text-[18px]" />}
                          onClick={() => setIsChatScheduleModal(true)}
                        />
                      </Tooltip>
                    </div>

                    <QuotationResponse
                      quotation={quotation}
                      setQuotation={setQuotation}
                    />
                    {formData?.previewLink?.image && (
                      <ChatPreviewLink
                        previewLink={formData?.previewLink}
                        removePreviewLink={removePreviewLink}
                      />
                    )}

                    <div className="flex w-[100%] items-center">
                      {inputValue &&
                        showSticker &&
                        stickerSuggestions.length > 0 && (
                          <div className="sticker-suggestions">
                            {stickerSuggestions.map((item) => (
                              <div
                                className="sticker-item-wrapper"
                                key={item.stickerId}
                                onClick={(e) => {
                                  e.preventDefault();
                                  setShowSticker(false);
                                  handleSendSticker(item);
                                  setInputValue("");
                                }}
                              >
                                <StickerItem
                                  resourceId={item.resourceId}
                                  frameCount={item.frameCount}
                                  size={60}
                                />
                              </div>
                            ))}
                          </div>
                        )}
                      <ContentEditableRichInput
                        value={inputValue}
                        onChange={(event) => {
                          setInputValue(event.target.value);
                          extractSingleLink(event.target.value);
                          handleTyping();
                        }}
                        placeholder={
                          languageMap?.["messageList.input.placeholder"] ??
                          "Message"
                        }
                        handleDataMentions={handleDataMentions}
                        ref={inputSendRef}
                        renderSuggestion={(item) => (
                          <div className="flex items-center gap-2 py-1">
                            <Avatar
                              style={{
                                backgroundColor: getColorFromInitial(
                                  item?.display[0],
                                ),
                                color: "white",
                                fontSize: "0.75rem",
                              }}
                              size={32}
                              src={item?.avatar ? getAvatar(item) : null}
                            >
                              {item?.id === "ALL" ? "@" : item?.display[0]}
                            </Avatar>
                            <span className="text-[0.75rem]">
                              {item?.id === "ALL"
                                ? languageMap?.[
                                    "messageList.input.mentionAll"
                                  ] ?? "Notify all group members @ALL"
                                : item?.display}
                            </span>
                          </div>
                        )}
                        onPaste={handleFileChange}
                        onKeyDown={onKeyDown}
                        onClick={() =>
                          onChangeUnreadConversation(
                            conversationList?.find(
                              (conversation) =>
                                conversation.conversationId ===
                                selectedConversation.conversationId,
                            ),
                            conversationList,
                            handleUpdateConversationList,
                          )
                        }
                        setStickerSuggestions={setStickerSuggestions}
                        setShowSticker={setShowSticker}
                        stickerKeywords={stickerKeywords}
                      />
                      <Button
                        className="bg-[#2a56b9] text-[white] mr-[10px]"
                        onClick={sendMessage}
                        icon={<FiSend size={16} />}
                      />
                    </div>

                    <FilesPreview
                      formData={formData}
                      setFormData={setFormData}
                      isOnlyView={true}
                    />
                  </div>
                </div>
              )}
          </div>
        </DndContext>
        {isShareMessageModal && (
          <ShareMessageModal
            isModalOpen={isShareMessageModal}
            isModalClose={() => setIsShareMessageModal(false)}
            shareMessage={dataShare}
          />
        )}

        {openModalShowMember && (
          <DirectoryProvider>
            <MemberModal
              selectedConversation={selectedConversation}
              openModalShowMember={openModalShowMember}
              handleCancelModalShowMember={handleCancelModalShowMember}
            />
          </DirectoryProvider>
        )}

        {isModalOpen && (
          <EditGroupModal
            isOpen={isModalOpen}
            onClose={closeModal}
            data={selectedConversation}
          />
        )}

        {isModalAddMember && (
          <AddMemberModal
            isModalOpen={isModalAddMember}
            isModalClose={() => setIsModalAddMember(false)}
            conversationId={selectedConversation.conversationId}
            conversationName={selectedConversation.name}
            orgList={orgList}
            setOrgList={setOrgList}
            screen={conversationType.CONVERSATION}
          />
        )}

        {isOpenModalConfirm && (
          <GeneralModal
            title={getTitleAndContent()?.title}
            content={getTitleAndContent()?.content}
            onCancel={closeModalConfirm}
            open={isOpenModalConfirm}
            onConfirm={handleOnConfirmDisableGroup}
          />
        )}

        <SideBarConversation
          isExitGroup={isExitGroup}
          isOpen={isMenu}
          onClose={() => setIsMenu(false)}
        />

        {isModalMembersReadUnread && (
          <MemberReadUnreadModal
            conversationId={selectedConversation?.conversationId}
            conversationType={selectedConversation?.type}
            messageId={selectedMessage?.messageId}
            onCancel={() => setIsModalMembersReadUnread(false)}
            isOpen={isModalMembersReadUnread}
          />
        )}

        {isOpenMediaModal && (
          <MediaVideoModal
            open={isOpenMediaModal}
            onClose={() => handleMediaModal(false, null)}
            mediaSrc={mediaVideo?.mediaVideoSrc}
            shortName={mediaVideo?.shortName}
          />
        )}

        {isChatScheduleModal && (
          <ChatScheduleModal
            onCancel={() => {
              setIsChatScheduleModal(false);
              setScheduleMessage(null);
            }}
            open={isChatScheduleModal}
            onConfirm={() => {}}
          />
        )}

        {isOpenModalVote && (
          <CreateVoteModal
            isOpen={isOpenModalVote}
            onClose={() => setIsOpenModalVote(false)}
          />
        )}
      </div>

      {panelStatus === PANEL_STATUS.GROUP_INFO && (
        <GroupInfoPanel jumpToMessage={jumpToMessage} />
      )}
      {panelStatus === PANEL_STATUS.MEDIA_STORAGE && (
        <MediaStoragePanel jumpToMessage={jumpToMessage} />
      )}
      {[
        PANEL_STATUS.SEARCH_CHAT,
        PANEL_STATUS.SEARCH_CHAT_AFTER_GROUP_INFO,
      ].includes(panelStatus) && <SearchPanel jumpToMessage={jumpToMessage} />}
    </div>
  );
};

export { ChatDetail };
